<mat-nav-list class="location-list">
  <div class="location-list-scroll">
    @for (location of locations(); track location.id) {
      <button
        mat-list-item
        class="location-item"
        [attr.cdkFocusInitial]="location.id === currentLocationId() ? '' : null"
        (click)="locationSelected.emit(location.id!)"
      >
        <div matListItemIcon class="location-icon-wrapper">
          @if (hasLogo(location)) {
            <img
              class="location-logo"
              [src]="location.logo!.url"
              width="32"
              height="32"
              alt=""
              (error)="onLogoError(location.id)"
            />
          } @else {
            <mat-icon fontSet="material-symbols-rounded">storefront</mat-icon>
          }
        </div>
        <span matListItemTitle>{{ location.name }}</span>
        @if (location.id === currentLocationId()) {
          <span matListItemMeta class="current-check">
            <mat-icon fontSet="material-symbols-rounded">check</mat-icon>
          </span>
        }
      </button>
    }
  </div>
  <mat-divider></mat-divider>
  <button mat-list-item class="location-item" (click)="addLocationClicked.emit()">
    <div matListItemIcon class="location-icon-wrapper">
      <mat-icon fontSet="material-symbols-rounded">add</mat-icon>
    </div>
    <span matListItemTitle>{{ 'location' | translate }}</span>
  </button>
</mat-nav-list>
